
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-and-condition",
      function () {
        return require("private-next-pages/terms-and-condition.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-and-condition"])
      });
    }
  